import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import {
  Box,
  Divider,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  MenuProps,
} from '@mui/material';
import { useState } from 'react';
import { MenuItemOptions } from './types';
import { hasSubMenuItems } from './utils';

interface KebabMenuListProps {
  anchorEl: HTMLElement | null;
  onMenuClose: () => void;
  menuItems: MenuItemOptions;
  menuProps?: Omit<MenuProps, 'open'>;
}

interface SubItemsMenuOptions {
  anchorEl: HTMLElement | null;
  menuItems: MenuItemOptions;
}

export const KebabMenuList = ({
  anchorEl,
  menuItems,
  onMenuClose,
  menuProps,
}: KebabMenuListProps) => {
  const [subItemsMenuOptions, setSubItemsMenuOptions] =
    useState<SubItemsMenuOptions | null>(null);

  const { anchorEl: subMenuAnchorEl, menuItems: subMenuItems } =
    subItemsMenuOptions || { anchorEl: null, menuItems: [] };

  if (menuItems.length === 0) {
    return null;
  }

  return (
    <>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={onMenuClose}
        {...menuProps}
      >
        {menuItems.map((menuItem, index) => {
          const hasSubMenu = hasSubMenuItems(menuItem);
          return (
            <Box key={index}>
              {menuItem.shouldShowDividerOnTop && (
                <Divider
                  sx={{
                    my: 0.8,
                  }}
                />
              )}
              <MenuItem
                onClick={(event) => {
                  if (hasSubMenu) {
                    setSubItemsMenuOptions({
                      anchorEl: event.currentTarget,
                      menuItems: menuItem.subItems,
                    });
                    return;
                  }
                  menuItem.onClick();
                  onMenuClose();
                }}
              >
                {menuItem.icon && <ListItemIcon>{menuItem.icon}</ListItemIcon>}
                <ListItemText>{menuItem.label}</ListItemText>
                {hasSubMenu && <ChevronRightIcon />}
              </MenuItem>
            </Box>
          );
        })}
      </Menu>
      {subItemsMenuOptions && (
        <KebabMenuList
          anchorEl={subMenuAnchorEl}
          onMenuClose={() => {
            setSubItemsMenuOptions(null);
            onMenuClose();
          }}
          menuItems={subMenuItems}
          menuProps={{
            anchorOrigin: {
              vertical: 'top',
              horizontal: 'left',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'right',
            },
            ...menuProps,
          }}
        />
      )}
    </>
  );
};
